import styled from 'styled-components'

export const GridContainer = styled.div`
  width: 100%;
  margin: 16px 0;
  overflow-x: scroll;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    margin: 0px;
  }
`

export const GridWrapper = styled.div<{ columnsCount: number }>`
  display: grid;
  grid-template-columns: 288px repeat(${(props) => props.columnsCount - 1}, 144px);

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    grid-template-columns: 144px repeat(${(props) => props.columnsCount - 1}, 144px);
  }
`

export const HeaderCell = styled.div`
  padding: 3px 6px;
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;

  &.first-cell {
    grid-column: 1;
    grid-row: 1;
  }
`

export const RowLabel = styled.div`
  padding: 3px 6px;
  display: flex;
  align-items: center;
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  box-sizing: border-box;
  grid-column: 1;
  width: 100%;
  max-width: 288px;

  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    max-width: 144px;
  }
`
export const DataCell = styled.div`
  padding: 3px 4px;
  box-sizing: border-box;
  width: 100%;

  div > div {
    height: 28px;
    width: 100%;
  }
`

export const PreviewContainer = styled.div`
  padding: 8px 4px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  gap: 22px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex-wrap: wrap;
    gap: 12px;
  }
`

export const PreviewLabel = styled.div`
  color: var(--Text-Secondary, #4d5874);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const PreviewContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  overflow: hidden;
`

export const PreviewItem = styled.div`
  font-size: 12px;
  color: var(--Text-Secondary, #4d5874);
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;

  .column-label {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    padding: 0;
  }
`
